import React from 'react';
import Logo from 'assets/logo.png';
const Landing = () => {
  return (
    <div className="bg-gray-900 h-screen flex justify-center items-center">
      <img className="h-40 mb-10" src={Logo} alt='LOGO LLT' />
    </div>
  );
};

export default Landing;
